import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType, TransparentButton } from '@checkmarx/cx-ui';
import EditUserProfileForm from './editUserProfileForm';
import ScreenLoaderContainer from '../../portal/controls/screenLoaderContainer';
import PortalTextBox from '../../portal/portalTextBox';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import classNames from 'classnames';
import styles from './style.scss';


@inject('translationsStore', 'editUserProfileStore')
@observer
export default class EditUserProfileContainer extends Component {

    state = {
        displaySuccessMessage: false,
        isApplication: true
    };

    resetMessages = _ => {

        this.setState({
            displaySuccessMessage: false
        });

        this.props.editUserProfileStore.setEditUserProfileErrorMessage('');
    }

    handleSubmitForm = e => {

        e.preventDefault();

        this.resetMessages();

        this.setState({
            displaySuccessMessage: false
        });

        this.props.editUserProfileStore.setEditUserProfileErrorMessage('');
    }

    handlePassword = e => {
        this.props.editUserProfileStore.setPassword(e.target.value);
        this.setState({ password: e.target.value });
    }

    handleSubmitForm = e => {

        e.preventDefault();

        this.resetMessages();

        const isValid = this.props.editUserProfileStore.validateForm(this.isApplication);
        
        if (!isValid) {

            const level = ToastrLevelsEnum.ERROR;
            const validationErrorMessage = this.props.translationsStore.translate('FORM_IS_NOT_COMPLETE_FILL_REQUIRED_FIELDS');
            this.props.editUserProfileStore.setEditUserProfileErrorMessage(validationErrorMessage);
            const message = validationErrorMessage;
            ToastrService.triggerToastr({ level, message });

            return;
        }

        this.props.editUserProfileStore.updateUserProfile()
            .then(() => {

                this.setState({
                    displaySuccessMessage: true
                });
            
                const level = ToastrLevelsEnum.SUCCESS;
                const message = this.props.translationsStore.translate('YOUR_PROFILE_UPDATED');
                ToastrService.triggerToastr({ level, message });
            });
    }

    handlePasswordOnBlur = e => this.props.editUserProfileStore.validatePassword(e.target.value);

    componentWillUnmount() {

        this.resetMessages();
        this.props.editUserProfileStore.resetForm();
        this.props.editUserProfileStore.resetValidations();
    }

    render() {

        let component = <ScreenLoaderContainer />;

        let url = this.props.editUserProfileStore.profileValues.userProfileGoBackUrl;
        let hideBackButton = (url === null || typeof url === 'undefined' || url.length === 0) ? true : false;

        if (this.props.editUserProfileStore.profileValues === undefined ||
            this.props.editUserProfileStore.authenticationProviderFormatted === undefined) {

            component = null;
        }
        else {

            component = <EditUserProfileForm displaySuccessMessage={this.state.displaySuccessMessage} />;
        }

        this.isApplication = this.props.editUserProfileStore.profileValues.authenticationProviderId === 1 ? true : false;

        return (
            <form onSubmit={this.handleSubmitForm}>
                {component}
                <div className='seperator' />
                <div hidden={!this.isApplication}>
                    <div className={classNames(styles.userProfileFormWrapper)} dir='rtl'>
                        <div dir='ltr'>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('PASSWORD')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('CURRENT_PASSWORD')} />}
                                onChange={this.handlePassword}
                                onBlur={this.handlePasswordOnBlur}
                                type="password"
                                width="330px"
                                value={this.state.password || ''}
                                errorText={this.props.editUserProfileStore.passwordValidationMessage}
                                dataCy={'profile-currentpassword-field'}
                            />
                        </div>
                    </div>
                </div>
                <div className='edit-profile-buttons-container'>
                    {hideBackButton ? null :
                        <div className='go-back'>
                            <TransparentButton
                                className='left'
                                type='button'
                                onClick={() => { window.location.href = url; }}
                                text={this.props.translationsStore.translate('Go Back')}
                            />
                        </div>
                    }
                    <div className='save-profile'>
                        <Button
                            type='submit'
                            text={this.props.translationsStore.translate('SAVE')}
                            inProgress={this.props.editUserProfileStore.updateUserInProgress}
                            dataCy={'update-profile-button'}
                        />
                    </div>
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/users/editUserProfile/editUserProfileContainer.jsx